import { Tabs } from "antd";
import { HelpMarkdownPayload } from "../../types/helpCentre.types";
import HelpMarkdown from "./HelpMarkdown";

interface MarkdownSectionProps {
	markdown: HelpMarkdownPayload;
	/** The selected tab, 0-based. Without it the tabs keep their own selection. */
	activeTab?: number;
	onTabChange?: (index: number) => void;
}

const EMPTY_TEXT = "This article has no content yet.";

/**
 * An article: one markdown text, or tabs of them. In tab mode only the tabs
 * show; the single text is kept by the editor as a draft.
 */
function MarkdownSection({
	markdown,
	activeTab,
	onTabChange,
}: Readonly<MarkdownSectionProps>) {
	if (!markdown.tabMode) {
		return markdown.markdownContent.trim() ? (
			<HelpMarkdown markdown={markdown.markdownContent} />
		) : (
			<p className="help-empty">{EMPTY_TEXT}</p>
		);
	}
	if (!markdown.markdownTabs.length) {
		return <p className="help-empty">{EMPTY_TEXT}</p>;
	}
	return (
		<Tabs
			className="help-tabs"
			activeKey={activeTab === undefined ? undefined : String(activeTab)}
			onChange={(key) => onTabChange?.(Number(key))}
			items={markdown.markdownTabs.map((tab, index) => ({
				key: String(index),
				label: tab.title,
				children: tab.content.trim() ? (
					<HelpMarkdown markdown={tab.content} />
				) : (
					<p className="help-empty">{EMPTY_TEXT}</p>
				),
			}))}
		/>
	);
}

export default MarkdownSection;
